export default __webpack_public_path__ + "static/media/razorpay.7ab54ae3.svg";